import Api from '../decorators/Api';
import HttpService from './HttpService';
import UserInfo from '../models/UserInfo';
import UserProfile from '../models/UserProfile';
import { UserUpdate } from '../models/UserUpdate';
import UserPasswordChange from '../models/UserPasswordChange';
import UserModel from '../models/UserModel';
import ProfileModel from '../models/ProfileModel';
import ProfilePermission from '../models/ProfilePermission';

@Api(process.env.VUE_APP_USER_API_URI)
export class UserService extends HttpService {
  public async getUserInfo(): Promise<UserInfo> {
    return (await this.get<UserInfo>('/connect/userInfo')).data;
  }
  public async listUsers() {
    return (await this.get<UserProfile[]>('/api/v1/Users?limit=999')).data;
  }
  public async listProfiles(Filter?: string) {
    return (await this.get<ProfileModel[]>('/api/v1/Profiles?limit=999', {
      params: { Filter },
    })).data;
  }
  public async getProfileById(id: string) {
    return (await this.get<ProfileModel>(`api/v1/profiles/${id}`)).data;
  }
  public async createProfile(profile: ProfileModel) {
    return (await this.post<{ Id: string }>('/api/v1/Profiles', profile, {
      headers: {
        TenantId: profile.AccountId,
      },
    })).data;
  }
  public async updateProfileById(id: string, Name: string) {
    await this.put(`api/v1/profiles/${id}`, { Name });
  }
  public async listProfilePermissions(profile: string) {
    return (await this.get<ProfilePermission[]>(`api/v1/permissions/profile/${profile}`)).data;
  }
  public async changeUserProfile(id: string, newProfileId: string, oldProfileId?: string) {
    if (oldProfileId) {
      await this.removeUserProfile(id, oldProfileId);
    }
    await this.addUserProfile(id, newProfileId);
  }
  public async addUserProfile(id: string, ProfileId: string) {
    await this.post(`/api/v1/Users/${id}/profiles`, { ProfileId });
  }
  public async removeUserProfile(id: string, ProfileId: string) {
    await this.delete(`/api/v1/Users/${id}/profiles/${ProfileId}`);
  }
  public async getUserProfile(id: string) {
    return (await this.get<UserProfile>(`/api/v1/Users/${id}`)).data;
  }
  public async updateProfile(id: string, data: UserUpdate) : Promise<void> {
    await this.put(`/api/v1/Users/${id}`, data);
  }
  public async changePassword(id: string, data: UserPasswordChange) : Promise<void> {
    await this.put(`/api/v1/Users/${id}/PasswordChange`, data);
  }
  public async create(user: UserModel): Promise<any> {
    return (await this.post('/api/v1/Users', user)).data;
  }
  public async update(id: string, user: UserModel): Promise<void> {
    await this.put(`/api/v1/Users/${id}`, user);
  }
  public async getOwnerFromCompany(id: string): Promise<UserModel | undefined> {
    const response = (await this.get<UserModel[]>('/api/v1/Users', {
      params: {
        Limit: 1,
        Filter: `Owner=true&&Company=${id}`,
      },
    })).data;
    if (response && response.length) {
      return response[0];
    }
    return undefined;
  }
}

export default new UserService();
